import {
  ReactElement,
} from "react";
// import { LogoDark } from "../../assets";
import { Link } from "react-router-dom";
import { Cancel, Logout , Size, VerticalLogo } from "../../assets";
import HeaderItem from "./header_item";
import CurrentDate from "./current_date";
import { Button, ProfileCard } from "../components";
import { connect } from "react-redux";
import { menuItems } from "../../core/utils";
import { logout } from "../../core/service";
interface IMyProps {
  handleDrawerClose?: any
  userData?: any;
}
export function HeaderResponsive({ handleDrawerClose, userData }: IMyProps): ReactElement {
  return (
    <div className="header-responsive">
       <div className="w-100">
       <div className=" text-start hide-desktop" >
              <Cancel/>
            </div>
      <div>
        <Link to="/" className="hide-mobile">
          <div className="logo">
            <img alt="هامرز" src={VerticalLogo} />
          </div>
        </Link>
        <div className=" hide-desktop">
          <ProfileCard  isMini image={userData?.picture} name={`${userData?.first_name} ${userData?.last_name}`} />
          <div className="horizontal-line">
            <hr />
            <Button myStyle="bg-green shadow-btn" title={userData?.brag_type} />
          </div >
        </div>
        <CurrentDate myStyle="hide-desktop" />
        {menuItems?.map((item, index) => {
          return (
            <HeaderItem
              name={item?.name}
              icon={item?.icon}
              link={item.path}
              // subMenu={item?.items}
              key={index}
            />
          )
        })}
      </div>
       </div>
      <div className="exit">
        <div className="hide-mobile cursor-pointer" onClick={handleDrawerClose}>
          <img alt="هامرز" src={Size} className="ps-1 " />
          مینیمایز منو
        </div>
        <div className="cursor-pointer" onClick={()=>logout()}>
          <img alt="هامرز" src={Logout} className="ps-1 " />
          خروج
        </div>
      </div>
    </div>
  );
}
const mapStateToProps = (dispatch: any) => {
  return {
    dispatch,
    userData: dispatch.general.userData,
  };
};
export default connect(mapStateToProps)(HeaderResponsive);
